module.exports = __webpack_public_path__ + "025039fb97a5377b39327cdac006da04.svg";